var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.classes),function(ref){
var color = ref[0];
var fontSize = ref[1];
var fontWeight = ref[2];
var textAlign = ref[3];
return _c('div',{key:color},[_c('div',{class:[color, fontSize, fontWeight, textAlign],staticStyle:{"letter-spacing":"normal !important","white-space":"pre-line !important"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }